// extracted by mini-css-extract-plugin
export default {"gotoBanner":"gotoapp-banner__gotoBanner___gLwyr","gotoBannerIcon":"gotoapp-banner__gotoBannerIcon___+f6ZP"};